export default __webpack_public_path__ + "static/media/GPA_Banner_Safety.c408c2e5.jpg";